import { jsx as o, Fragment as M, jsxs as b } from "react/jsx-runtime";
import j from "remark-gfm";
import * as s from "react";
import { useCopilotInstruction as D } from "./global-state.js";
import { undent as I } from "../session.js";
import { Markdown as N } from "../node_modules/react-markdown/lib/index.js";
const h = s.createContext(null);
function G({
  children: r,
  components: t,
  remarkPlugins: c = []
}) {
  const { markdownComponents: a, extraComponentDescription: p } = s.useMemo(() => {
    const i = {}, m = {}, u = [], { code: g = F, pre: w = $, ...y } = t;
    for (const [n, e] of Object.entries(y))
      typeof e == "function" ? i[n] = e : e && typeof e.component == "function" && (m[n] = e.component, typeof e.description == "string" && e.description.trim().length > 0 && u.push(`### ${n}
${I(e.description).trim()}`));
    const k = w, x = g;
    return i.pre = function({ children: n, ...e }) {
      return (n?.props?.className ?? "") === "language-render-component" ? /* @__PURE__ */ o(M, { children: n }) : /* @__PURE__ */ o(k, { ...e, children: n });
    }, i.code = ({ className: n, children: e, ...d }) => {
      if (n === "language-render-component")
        try {
          const v = JSON.parse(e.trim()), { componentName: l, props: P } = v, f = m[l];
          return f == null ? /* @__PURE__ */ b("div", { children: [
            "Failed to render ",
            l
          ] }) : /* @__PURE__ */ o(f, { ...P });
        } catch {
          return /* @__PURE__ */ o("div", { children: "Failed to render custom component" });
        }
      return /* @__PURE__ */ o(x, { ...d, className: n, children: e });
    }, { markdownComponents: i, extraComponentDescription: u.join(`

`) };
  }, [t]);
  D({
    instruction: `## Content Guidelines

1. You have access to github flavored markdown. Lean on it to make your responses more readable and engaging. 
${p.length > 0 ? `2. In addition. You are rendering this chat with a few special components. 

  To securely render these components you must:
  
  1. Emit a code fence with the language \`render-component\` 
  2. Insert JSON with a key of \`componentName\` and \`props\`. We will feed the props directly into the referenced react component.

  For example, if you have a component called \`ProfileCard\`, you use it like this:

  \`\`\`render-component
  { "componentName": "ProfileCard", "props": {"userId": "12345" } }
  \`\`\`

  When you emit this, this component will render as a React component in the chat.
  This syntax the equivalent of writing <ProfileCard userId="12345" /> in react.

List of available components:    

${p}` : ""}`
  });
  const C = s.useMemo(() => ({ components: a, remarkPlugins: c }), [a, c]);
  return /* @__PURE__ */ o(h.Provider, { value: C, children: r });
}
function J({ children: r }) {
  const t = s.useContext(h);
  if (t == null)
    throw new Error("Markdown must be used within CopilotProvider");
  return /* @__PURE__ */ o(
    N,
    {
      remarkPlugins: [j, ...Array.isArray(t.remarkPlugins) ? t.remarkPlugins : []],
      rehypePlugins: t.rehypePlugins,
      components: t.components,
      children: r
    }
  );
}
function $(r) {
  return /* @__PURE__ */ o("pre", { ...r });
}
function F(r) {
  return /* @__PURE__ */ o("code", { ...r });
}
export {
  G as CopilotProvider,
  J as Markdown
};
